import { render, staticRenderFns } from "./cube_5.vue?vue&type=template&id=fca7603a&scoped=true&"
import script from "./cube_5.vue?vue&type=script&lang=js&"
export * from "./cube_5.vue?vue&type=script&lang=js&"
import style0 from "./cube_5.vue?vue&type=style&index=0&id=fca7603a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca7603a",
  null
  
)

export default component.exports